import request from '@/utils/request'

// 查询维修价格参考列表分页
export function fetchList(query) {
    return request({
        url: '/upkeep/quotation/page',
        method: 'get',
        params: query,
    })
}
// 查询维修价格参考详细
export function getObj(id) {
    return request({
        url: '/upkeep/quotation/detail?id=' + id,
        method: 'get',
    })
}
// 新增维修价格参考
export function addObj(data) {
    return request({
        url: '/upkeep/quotation/add',
        method: 'post',
        data: data,
    })
}
// 禁用启用 维修首页状态
export function statusObj(data) {
    return request({
        url: '/upkeep/quotation/status',
        method: 'post',
        data: data,
    })
}
// 修改维修价格参考
export function putObj(data) {
    return request({
        url: '/upkeep/quotation/edit',
        method: 'post',
        data: data,
    })
}
// 删除维修价格参考
export function delObj(data) {
    return request({
        url: '/upkeep/quotation/delete',
        method: 'post',
        data: data,
    })
}
